
import { getUserInviteDetailList } from '@/api/userManaging';
import { PageQuery } from '@/mixins/page_query';
import LogUtils from 'panda-log';
import { Component, Mixins, Prop } from 'vue-property-decorator';
@Component
export default class InvitationDetail extends Mixins(PageQuery) {
  private tableData = [];
  loading: boolean = false;
  @Prop() info!: any;
  share_uid: number = 0;
  fp_num: number = 0;
  ot_num: number = 0;
  searchList() {
    this.page_query.page = 1;
    this.getList();
  }
  async getList() {
    try {
      this.loading = true;
      const data = { ...this.page_query, share_uid: this.share_uid };
      const res = await getUserInviteDetailList(data);
      if (res && (res as any).code === 0) {
        this.tableData = res.data.rows;
        this.total = res.data.total;
        this.fp_num = res.data.fp_num;
        this.ot_num = res.data.ot_num;
      }
    } catch (error) {
      LogUtils.debug(error);
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    this.share_uid = this.info.id;
    this.pageFn = this.getList;
    this.getList();
  }
}
